import { Link, useSearchParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DadosEmpresaTab } from './components/DadosEmpresaTab';
import { GestaoUsuariosTab } from './components/GestaoUsuariosTab';
import { ParametrosFiscalTab } from './components/ParametrosFiscalTab';
import { GestaoCertificadosTab } from './components/GestaoCertificadosTab';
import { AuditoriaTab } from './components/AuditoriaTab';
import { IntegracoesTab } from './components/IntegracoesTab';

const ABAS_VALIDAS = [
  'dados-empresa',
  'usuarios',
  'parametros-fiscal',
  'certificados',
  'integracoes',
  'auditoria',
];

export function ConfiguracoesPage() {
  const [searchParams] = useSearchParams();
  const abaInicial = ABAS_VALIDAS.includes(searchParams.get('tab') || '')
    ? (searchParams.get('tab') as string)
    : 'dados-empresa';

  return (
    <div className="min-h-screen bg-background">
      {/* Cabeçalho */}
      <header className="border-b border-border bg-card sticky top-0 z-30 shadow-sm">
        <div className="px-6 py-4">
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="shrink-0 hover:opacity-75 transition-opacity"
              title="Voltar ao menu principal"
            >
              <div className="h-10 w-[45px] relative overflow-hidden">
                <img
                  src="/logo-it-works.png"
                  alt="IT Works"
                  width={50}
                  height={40}
                  className="absolute top-0 left-0 object-cover object-left h-10"
                />
              </div>
            </Link>
            <div className="border-l border-border pl-4">
              <h1 className="text-base font-semibold text-foreground leading-tight">
                Administração
              </h1>
              <p className="text-xs text-muted-foreground">
                Configurações do sistema, usuários e auditoria
              </p>
            </div>
          </div>
        </div>
      </header>

      <main className="px-6 py-6">
        <Tabs defaultValue={abaInicial} className="space-y-6">
          <TabsList className="h-10 gap-1">
            <TabsTrigger value="dados-empresa" className="px-4">
              Dados da Empresa
            </TabsTrigger>
            <TabsTrigger value="usuarios" className="px-4">
              Gestão de Usuários
            </TabsTrigger>
            <TabsTrigger value="parametros-fiscal" className="px-4">
              Parâmetros Fiscal
            </TabsTrigger>
            <TabsTrigger value="certificados" className="px-4">
              Gestão de Certificados
            </TabsTrigger>
            <TabsTrigger value="integracoes" className="px-4">
              Integrações
            </TabsTrigger>
            <TabsTrigger value="auditoria" className="px-4">
              Auditoria
            </TabsTrigger>
          </TabsList>

          <DadosEmpresaTab />
          <GestaoUsuariosTab />
          <ParametrosFiscalTab />
          <GestaoCertificadosTab />
          <IntegracoesTab />
          <AuditoriaTab />
        </Tabs>
      </main>
    </div>
  );
}
